import { update } from 'Emitter';
import { MEASUREMENT } from 'StateEvents';
import { replaceMacros, cacheBusterMacro } from 'Misc/format';

export default class Measurer {
  onUpdate(nextState, prevState, changes) {
    if(changes.configuration) {
      this.configuration = nextState.configuration;
    }
  }

  queueRequests(events, name, params = {}) {
    const macros = Object.assign({}, cacheBusterMacro(), params.macros);
    
    events = events.map( ({ src, format }) => ({
        src: replaceMacros(src, macros),
        format
      })
    );

    return update(MEASUREMENT.EVENT_LOGGED, 'queueRequests', { events, name, params });
  }
}


// WEBPACK FOOTER //
// ./src/Services/Measurement/Measurer.js